import React, {FC} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import {tryParseObject} from "../../../helpers/tryParseObject";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const getCardUrl = (cardContextInfo: any, cardId: any) => {

    if (!cardId) return `${process.env.REACT_APP_URL_BOOKS_COM}?shouldForcedLogin=true&saveLoginUrl=true`

    const isZelandCard = (cardContextInfo?.cardProviderId === 'zeland') && cardContextInfo?.countryId  && cardContextInfo?.museumId;

    if (isZelandCard) return `${process.env.REACT_APP_URL_ZELAND}/card/${cardId}?countryMuseum=${cardContextInfo?.museumId}`

    const baseUrl = getRepBaseByProvider(cardContextInfo?.cardProviderId);
    const context = cardContextInfo?.contexts?.length > 0 ? cardContextInfo?.contexts[0] : ''
    const contextPath = (context && cardContextInfo?.cardProviderId !== 'artz') ? `/${context}` : ''

    return `${baseUrl}${contextPath}/card/${cardId}`
}

export const NotificationBook: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const cardContextInfo = typeof(firstLike?.context) === 'string' && tryParseObject({ str: firstLike?.context, undefinedOnError: true });
    const { t } = useTranslation()

    const declOfNum = (n: number, titles: string[]) => {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
    }

    const onExternalLinkClick = () => {
        window.open(getCardUrl(cardContextInfo, entity?.entityId), '_blank')
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <span onClick={() => window.open(process.env.REACT_APP_URL_DESIGN + CreateLinkTo.designer(initiator?.accountId), '_blank')}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </span>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : false}
            {notificationTitle}
            {' '}
            <DivLink onClick={onExternalLinkClick}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}import React, {FC} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import {tryParseObject} from "../../../helpers/tryParseObject";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const getCardUrl = (cardContextInfo: any, cardId: any) => {

    if (!cardId) return `${process.env.REACT_APP_URL_BOOKS_COM}?shouldForcedLogin=true&saveLoginUrl=true`

    const isZelandCard = (cardContextInfo?.cardProviderId === 'zeland') && cardContextInfo?.countryId  && cardContextInfo?.museumId;

    if (isZelandCard) return `${process.env.REACT_APP_URL_ZELAND}/card/${cardId}?countryMuseum=${cardContextInfo?.museumId}`

    const baseUrl = getRepBaseByProvider(cardContextInfo?.cardProviderId);
    const context = cardContextInfo?.contexts?.length > 0 ? cardContextInfo?.contexts[0] : ''
    const contextPath = (context && cardContextInfo?.cardProviderId !== 'artz') ? `/${context}` : ''

    return `${baseUrl}${contextPath}/card/${cardId}`
}

export const NotificationBook: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const cardContextInfo = typeof(firstLike?.context) === 'string' && tryParseObject({ str: firstLike?.context, undefinedOnError: true });
    const { t } = useTranslation()

    const declOfNum = (n: number, titles: string[]) => {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
    }

    const onExternalLinkClick = () => {
        window.open(getCardUrl(cardContextInfo, entity?.entityId), '_blank')
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <span onClick={() => window.open(process.env.REACT_APP_URL_DESIGN + CreateLinkTo.designer(initiator?.accountId), '_blank')}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </span>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : false}
            {notificationTitle}
            {' '}
            <DivLink onClick={onExternalLinkClick}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}